import { Formik, Field } from 'formik';
import { object, string } from 'yup';
import React, { useEffect, useState } from 'react';
import { Text, Flex, Image, Button } from 'rebass';
import { getAuthorizedHeaders } from 'utils/api';
import reviewerImage1 from './assets/reviewer-image1.png';
import reviewerImage2 from './assets/reviewer-image2.png';
import reviewerImage3 from './assets/reviewer-image3.png';
import Wrapper from 'gift-certificate/Wrapper';
import TextField from 'app/form/formik/text/index';
// Updated gift-box artwork from the redeem design (replaces the older GiftBox.png).
import GiftBox from './assets/GiftBox2.png';
import { label } from './Step3';
import Banner from 'app/payment/Banner';
import apiBase from 'utils/api-base';
import { useMobileCheckHook } from 'story-media/hooks';

const userReviews = [{
    title: 'The Best Keepsake in the Making!',
    review: 'Joining the beta, I knew this would be special – but it’s even better than I imagined! As a busy new mom, it’s been so easy to capture Ellie’s firsts: her smiles, giggles, and even her messy spaghetti night. Knowing this will become a beautiful keepsake book? Absolutely priceless.',
    reviewer: {
        name: 'Emily, First-Time Mom',
        image: reviewerImage1
    }
},
{
    title: 'A Must-Have for Every Parent',
    review: 'During the holidays, we spent some quality family time together with our 17-year-old. One of the wonderful things we did was reread his Baby’s First Year scrapbook, which was diligently created by my wife 17 years ago. It was fantastic! Great, great memories, most of which would have been forgotten. I strongly recommend that everybody create a book like this. And wow — this would have been 100x easier with Baby’s First Year! And video too! Take it from an older parent — this should be a really easy decision!',
    reviewer: {
        name: 'Martin S.',
        image: reviewerImage2
    }
},
{
    title: 'The Perfect Start to Capturing Our Memories!',
    review: `When my parents gave me a Baby's First Year gift certificate, I was thrilled! This made it so easy to start documenting Lily’s milestones and adding photos and videos. It’s already becoming a beautiful collection of moments, and I can’t wait to see how it all comes together in the book.`,
    reviewer: {
        name: 'Sarah, Proud Mama of Noah',
        image: reviewerImage3
    }
}]

const baseUrl = apiBase.replace('/v2', '');

const RedeemCertificate = ({ isSubmitting, onStepUp, redeemCode, setRedeemCode, firePostMemberEvent, setNameOfGiver }) => {
    const isProfileFilled = false
    const [status, setStatus] = useState({ type: '', message: '' });
    const isFromMobile = useMobileCheckHook();

    const [showReviews, setShowReviews] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [showReviews]);

    const requestOptions = () => ({
        method: 'GET',
        headers: getAuthorizedHeaders(),
    });

    const initialValues = {
        'gift-certificate': redeemCode || '',
    };

    function getErrorMessage(code) {
        switch (code) {
            case "already_redeemed":
                return 'This certificate has already been redeemed';
            case 'unrecognized':
                return 'This certificate code is not recognized';
            default:
                return 'An error occurred while redeeming the certificate';
        }
    }

    async function getCouponDetails(code = null) {
        const resp = await fetch(`${baseUrl}/v3/commerce/gift_certificates/${code || redeemCode}`, requestOptions())
        const response = await resp.json();
        if (response?.data === null || response?.errors?.length > 0) {
            response?.errors.map((err) => {

                setStatus({
                    type: 'error',
                    message: getErrorMessage(err?.code),
                    subTitle: err?.detail.includes('contact us') ? err?.detail.replace(
                        'contact us',
                        `<a href="mailto:hello@babyyearbooks.com" target="_blank" style="text-decoration-line:underline; cursor:pointer; font-weight:500; color: inherit">contact us</a>`
                    ) : err?.detail
                })
            })
            return false
        }

        setNameOfGiver(response?.data?.attributes?.['name_of_giver'])
        setStatus({ type: 'success', message: 'Gift card applied successfully' })
        return true
    }

    useEffect(() => {
        if (redeemCode)
            getCouponDetails()
    }, [redeemCode])

    const validationSchema = object().shape({
        'gift-certificate': string().required('Enter a valid certificate code'),
    });

    const isInitialValid = validationSchema.isValidSync(initialValues);

    async function onSubmit() {
        const resp = await getCouponDetails()
        if (resp)
            onStepUp()
    }

    if (showReviews)
        return <Wrapper
            percentComplete={0}
            bg="aliceBlue"
            showFooter={false}
            hideSkip
        >
            <Flex flexDirection="column">
                <Flex flexDirection="column" maxWidth="95vw" m="auto">
                    <Image src={GiftBox} maxWidth={200} m="auto" />
                    <Text
                        textAlign="center"
                        color="codGrey"
                        fontFamily="Bitter"
                        fontSize="30px"
                        fontStyle="normal"
                        fontWeight={600}
                        lineHeight="120%"
                        letterSpacing="-0.18px"
                        mt='20px'
                    >
                        Someone sent you a baby’s first year book!
                    </Text>
                    <Text
                        color="#34495E"
                        fontSize={16}
                        fontFamily="Poppins"
                        lineHeight="150%"
                        fontWeight={400}
                        letterSpacing="-0.32px"
                        textAlign="center"
                        mt={2}
                    >
                        With Baby’s First Year, you don’t just preserve memories; you bring them to life!
                    </Text>

                    <Button
                        height={48}
                        py={1}
                        px={5}
                        bg="brand"
                        onClick={() => {
                            firePostMemberEvent('gc')
                            setShowReviews(false)
                        }}
                        sx={{ borderRadius: '100px' }}
                        my="30px"
                    >
                        Redeem Gift
                    </Button>
                </Flex>
            </Flex>
        </Wrapper>

    return (
        <Formik
            {...{ initialValues, validationSchema, isInitialValid }}
            onSubmit={onSubmit}
        >
            {({ values, handleSubmit }) => (
                <Wrapper
                    hideSkip
                    onSubmit={handleSubmit}
                    isDisabled={isSubmitting}
                    showFooter
                    bg="aliceBlue"
                    nextButtonText='Redeem certificate'
                >
                    <Flex flexDirection="column" m="auto" maxWidth={["95vw", 480]}>
                        <Image src={GiftBox} maxWidth={200} m="auto" />

                        <Text
                            color="codGrey"
                            textAlign="center"
                            fontFamily="Bitter"
                            fontSize={[24, 32]}
                            lineHeight={["34px", "42px"]}
                            letterSpacing="-0.6"
                            mt={5}
                            fontWeight={600}
                            mb={1}
                        >
                            Redeem your gift certificate
                        </Text>

                        <Field
                            component={TextField}
                            name="gift-certificate"
                            label={label("Gift Certificate", true)}
                            placeholder="XXXX-XXXX-XXX"
                            showError
                            my={3}
                            onChange={(e) => {
                                if (e.target.value.length === 14) {
                                    setStatus({ type: '', message: '' })
                                    setRedeemCode(e.target.value)
                                }
                            }}
                        />
                        {!!status.message && (
                            <Banner
                                bg={status.type === 'success' ? 'successBg' : 'pinks.1'}
                                color={status.type === 'success' ? 'success' : 'pinks.5'}
                                heading={status.message}
                                text={status.subTitle}
                                p="16px"
                                size={'small'}
                            />
                        )}
                    </Flex>
                </Wrapper>
            )}
        </Formik>

    );
};

export default RedeemCertificate;
